// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2485":"79a0f060","2947":"11b01132","4795":"8971d2ba","6378":"1b4bcca1","7212":"f2d44e4f","7648":"eb4959c6"}[chunkId] + ".chunk.css";
};